import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  hcDefsList: {
    data: []
  },
};

export const hcDefsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_HCDEFS_LIST:
      return {
        ...state,
        hcDefsList: action.payload,
      };
    default:
      return state;
  }
};
